import { Box } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";

const CustomVideoPlayer = ({
  src,
  isPlaying = false,
  width = "100%",
  height = "100%",
  onClickPlay,
  wrapperClass = "",
  ...rest
}: any) => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let timeoutId: any = null;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Debounce to prevent flickering on rapid scrolling
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          setIsVisible(entry.isIntersecting);
        }, 50);
      },
      {
        threshold: 0.5,
        rootMargin: "0px",
      }
    );

    if (containerRef.current) observer.observe(containerRef.current);

    return () => {
      clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, []);

  return (
    <Box ref={containerRef} className={wrapperClass}>
      <ReactPlayer
        src={src}
        playing={isPlaying && isVisible}
        controls={true}
        volume={0.5}
        loop={true}
        config={{ youtube: { color: "red" } }}
        onPlay={() => onClickPlay(true)}
        onPause={() => {
          if (!isPlaying) return;
          onClickPlay(false);
        }}
        width={width}
        height={height}
        {...rest}
        style={{
          width: "100%",
          height: "100%",
          aspectRatio: "16/9",
          minWidth: 100,
        }}
      />
    </Box>
  );
};

export default CustomVideoPlayer;
